export default __webpack_public_path__ + "static/wsl-logo-1b90825e400900205ee5aa3e8ec0f6a7.svg";